import { Meal } from "@/clients/models/Meal";

const FRUIT_MEAL_ID = "ST0015";

export const isFruitMeal = (meal: Meal): boolean =>
  meal.id === FRUIT_MEAL_ID; // removed the check if name contains fruit since "fruit yoghurt" is not fruit
